import { Colors, ColorsType } from '@common/tokens';

/** Luminance (0–255) above which a background is considered light. */
const LIGHT_BACKGROUND_THRESHOLD = 150;

/**
 * Picks a readable text color for a background token: dark text on light
 * backgrounds, white on dark ones.
 */
export function getReadableTextColor(color: ColorsType): ColorsType {
  const isLightBackground =
    getPerceivedLuminance(Colors[color]) > LIGHT_BACKGROUND_THRESHOLD;

  return isLightBackground ? 'midnightDarker' : 'white';
}

/** Perceived luminance (0–255) of a hex color, using ITU-R BT.601 weights. */
function getPerceivedLuminance(hexColor: string): number {
  const [red, green, blue] = parseRgbChannels(hexColor);

  return 0.299 * red + 0.587 * green + 0.114 * blue;
}

function parseRgbChannels(hexColor: string): number[] {
  const hex = expandShorthandHex(hexColor.replace('#', ''));

  return [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16));
}

/** '#fff'-style shorthand → 'ffffff'-style full form. */
function expandShorthandHex(hex: string): string {
  if (hex.length !== 3) return hex;

  return hex
    .split('')
    .map((char) => char + char)
    .join('');
}
